import { render } from "./HomeDetail.vue?vue&type=template&id=10a58327&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"

import "./HomeDetail.vue?vue&type=style&index=0&id=10a58327&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a58327"]])

export default __exports__